import { defineMessages } from 'react-intl';

export const DetailDescriptions = defineMessages({
  title: {
    id: 'app.DetailDescriptions.title',
    defaultMessage: 'Detail',
  },
  detailPhotosLabel: {
    id: 'app.common.detailPhotosLabel',
    defaultMessage: 'Fotky detail',
  },
  serialNumber: {
    id: 'app.common.serialNumber',
    defaultMessage: 'Sériové číslo',
  },
  accessibility: {
    id: 'app.common.accessibility',
    defaultMessage: 'Přístupnost',
  },
  lorawanRssi: {
    id: 'app.common.lorawanRssi',
    defaultMessage: 'Signál LoRaWAN',
  },
  nbiotRssi: {
    id: 'app.common.nbiotRssi',
    defaultMessage: 'Signál NB-IoT',
  },
  unmeasured: {
    id: 'app.common.unmeasured',
    defaultMessage: 'Nezměřena',
  },
  note: {
    id: 'app.ServiceInspection.note',
    defaultMessage: 'Poznámka',
  },
});

export const LocationDescriptions = defineMessages({
  title: {
    id: 'app.LocationDescriptions.title',
    defaultMessage: 'Umístění a kontext',
  },
  photoContext: {
    id: 'app.common.photoContext',
    defaultMessage: 'Fotky kontext',
  },
  commodity: {
    id: 'app.common.commodity',
  },
  newMeter: {
    id: 'app.common.newMeter',
    defaultMessage: 'Nové měřidlo',
  },
  newMeterStatus: {
    id: 'app.common.newMeterStatus',
    defaultMessage: '{value, select, 0 {Stávající měřidlo} 1 {Návrh nového měření} other {Neznámý stav}}',
  },
  remoteReadingOwner: {
    id: 'app.common.remoteReadingOwner',
    defaultMessage: 'Kdo odečítá',
  },
  apiKey: {
    id: 'app.AuthPage.apiKey',
    defaultMessage: 'API klíč',
  },
  meterModelLabel: {
    id: 'app.common.meterModelLabel',
    defaultMessage: 'Model měřidla',
  },
  monitoredEntity: {
    id: 'app.common.monitoredEntity',
    defaultMessage: 'Název měřidla',
  },
  building: {
    id: 'app.common.building',
    defaultMessage: 'Budova',
  },
  floor: {
    id: 'app.common.floor',
    defaultMessage: 'Podlaží',
  },
  owner: {
    id: 'app.common.owner',
    defaultMessage: 'Vlastník',
  },
  tenant: {
    id: 'app.common.tenant',
    defaultMessage: 'Nájemce',
  },
  outsideNotSpecified: {
    id: 'app.common.outsideNotSpecified',
    defaultMessage: 'Venku / Neupřesněno',
  },
  meterModelNotSpecified: {
    id: 'app.common.meterModelNotSpecified',
    defaultMessage: 'Model měřidla není vybrán',
  },
  internalSupplyPointCode: {
    id: 'app.common.internalSupplyPointCode',
    defaultMessage: 'Identifikace OM',
  },
});

export const ReadingDescriptions = defineMessages({
  mounting: {
    id: 'app.ReadingDescriptions.mounting',
    defaultMessage: 'Osazení',
  },
  requiresManualAks: {
    id: 'app.common.requiresManualAks',
    defaultMessage: 'Vypnout Robot',
  },
  yes: {
    id: 'app.common.yes',
  },
  no: {
    id: 'app.common.no',
  },
  modulePhotos: {
    id: 'app.common.modulePhotos',
    defaultMessage: 'Fotky modulu',
  },
  installationStatus: {
    id: 'app.common.installationStatus',
    defaultMessage: 'Stav osazení',
  },
  meterMountTechnology: {
    id: 'app.common.meterMountTechnology',
    defaultMessage: 'Technologie osazení',
  },
  remoteReadingOwner: {
    id: 'app.common.remoteReadingOwner',
    defaultMessage: 'Kdo odečítá',
  },
  remoteReadingSerialPlaceholder: {
    id: 'app.common.remoteReadingSerialPlaceholder',
    defaultMessage: 'Sériové číslo modulu',
  },
  manufactured: {
    id: 'app.Select.manufacturedLabel',
    defaultMessage: 'Rok výroby měřidla',
  },
  calibrated: {
    id: 'app.Select.calibratedLabel',
    defaultMessage: 'Rok cejchování měřidla',
  },
});

export const RegisterDescriptions = defineMessages({
  registerName: {
    id: 'app.common.registerName',
    defaultMessage: 'Nazev registru {register}',
  },
  registerStatus: {
    id: 'app.common.registerStatus',
    defaultMessage: 'Stav registru',
  },
  registerPhotos: {
    id: 'app.common.registerPhotos',
    defaultMessage: 'Fotky odečtu registru',
  },
  obis: {
    id: 'app.common.registerObis',
  },
  tariff: {
    id: 'app.common.registerTariff',
  },
});

export const ReviewStepContent = defineMessages({
  recordSentSuccess: {
    id: 'app.common.recordSentSuccess',
    defaultMessage: 'Záznam byl úspěšně odeslán',
  },
  recordSentError: {
    id: 'app.common.recordSentError',
    defaultMessage: 'Při odesílání záznamu došlo k chybě',
  },
  queuedMetersSentSuccess: {
    id: 'app.common.queuedMetersSentSuccessPasport',
    defaultMessage: 'Pasport uložen, nezapomeňte jej odeslat na server pomocí synchronizačního tlačítka',
  },
  mapPositionError: {
    id: 'app.ReviewStepContent.mapPositionError',
    defaultMessage: 'Na kartě pozice v mapě je chyba',
  },
  note: {
    id: 'app.ServiceInspection.note',
  },
  notePlaceholder: {
    id: 'app.ServiceInspection.notePlaceholder',
  },
});

export const ReviewStepFooter = defineMessages({
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
  sending: {
    id: 'app.common.sending',
    defaultMessage: 'Odesílám...',
  },
  confirm: {
    id: 'app.common.confirm',
    defaultMessage: 'Potvrdit',
  },
});
